import { atom } from "recoil";

export const versionState = atom({
  key: "versionState",
  default: null,
});
